/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import {
  CreateLabelRequest,
  CreateLabelRequestFromJSON,
  CreateLabelRequestToJSON,
  CreateLabelResponse,
  CreateLabelResponseFromJSON,
  CreateLabelResponseToJSON,
  GetLabelResponse,
  GetLabelResponseFromJSON,
  GetLabelResponseToJSON,
  GetLabelsResponse,
  GetLabelsResponseFromJSON,
  GetLabelsResponseToJSON,
  SortLabelsRequest,
  SortLabelsRequestFromJSON,
  SortLabelsRequestToJSON,
  SortLabelsResponse,
  SortLabelsResponseFromJSON,
  SortLabelsResponseToJSON,
  UpdateLabelRequest,
  UpdateLabelRequestFromJSON,
  UpdateLabelRequestToJSON,
  UpdateLabelResponse,
  UpdateLabelResponseFromJSON,
  UpdateLabelResponseToJSON
} from '../models'

export interface UserV1LabelsLabelIdDeleteRequest {
  labelId: string
}

export interface UserV1LabelsLabelIdGetRequest {
  labelId: string
}

export interface UserV1LabelsLabelIdPutRequest {
  labelId: string
  updateLabelRequest?: UpdateLabelRequest
}

export interface UserV1LabelsPostRequest {
  createLabelRequest?: CreateLabelRequest
}

export interface UserV1LabelsSortPutRequest {
  sortLabelsRequest?: SortLabelsRequest
}

/**
 *
 */
export class ApiUserV1LabelsApi extends runtime.BaseAPI {
  /**
   * ラベル一覧を取得する
   * index
   */
  async userV1LabelsGetRaw(
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<runtime.ApiResponse<GetLabelsResponse>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/user/v1/labels`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, jsonValue => GetLabelsResponseFromJSON(jsonValue))
  }

  /**
   * ラベル一覧を取得する
   * index
   */
  async userV1LabelsGet(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<GetLabelsResponse> {
    const response = await this.userV1LabelsGetRaw(initOverrides)
    return await response.value()
  }

  /**
   * ラベルを削除する
   * destroy
   */
  async userV1LabelsLabelIdDeleteRaw(
    requestParameters: UserV1LabelsLabelIdDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.labelId === null || requestParameters.labelId === undefined) {
      throw new runtime.RequiredError(
        'labelId',
        'Required parameter requestParameters.labelId was null or undefined when calling userV1LabelsLabelIdDelete.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/user/v1/labels/{label_id}`.replace(
          `{${'label_id'}}`,
          encodeURIComponent(String(requestParameters.labelId))
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * ラベルを削除する
   * destroy
   */
  async userV1LabelsLabelIdDelete(
    requestParameters: UserV1LabelsLabelIdDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<void> {
    await this.userV1LabelsLabelIdDeleteRaw(requestParameters, initOverrides)
  }

  /**
   * ラベル詳細を取得する
   * show
   */
  async userV1LabelsLabelIdGetRaw(
    requestParameters: UserV1LabelsLabelIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<runtime.ApiResponse<GetLabelResponse>> {
    if (requestParameters.labelId === null || requestParameters.labelId === undefined) {
      throw new runtime.RequiredError(
        'labelId',
        'Required parameter requestParameters.labelId was null or undefined when calling userV1LabelsLabelIdGet.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/user/v1/labels/{label_id}`.replace(
          `{${'label_id'}}`,
          encodeURIComponent(String(requestParameters.labelId))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, jsonValue => GetLabelResponseFromJSON(jsonValue))
  }

  /**
   * ラベル詳細を取得する
   * show
   */
  async userV1LabelsLabelIdGet(
    requestParameters: UserV1LabelsLabelIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<GetLabelResponse> {
    const response = await this.userV1LabelsLabelIdGetRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * ラベルを更新する
   * update
   */
  async userV1LabelsLabelIdPutRaw(
    requestParameters: UserV1LabelsLabelIdPutRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<runtime.ApiResponse<UpdateLabelResponse>> {
    if (requestParameters.labelId === null || requestParameters.labelId === undefined) {
      throw new runtime.RequiredError(
        'labelId',
        'Required parameter requestParameters.labelId was null or undefined when calling userV1LabelsLabelIdPut.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/user/v1/labels/{label_id}`.replace(
          `{${'label_id'}}`,
          encodeURIComponent(String(requestParameters.labelId))
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: UpdateLabelRequestToJSON(requestParameters.updateLabelRequest)
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, jsonValue => UpdateLabelResponseFromJSON(jsonValue))
  }

  /**
   * ラベルを更新する
   * update
   */
  async userV1LabelsLabelIdPut(
    requestParameters: UserV1LabelsLabelIdPutRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<UpdateLabelResponse> {
    const response = await this.userV1LabelsLabelIdPutRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * ラベルを作成する
   * create
   */
  async userV1LabelsPostRaw(
    requestParameters: UserV1LabelsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<runtime.ApiResponse<CreateLabelResponse>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/user/v1/labels`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CreateLabelRequestToJSON(requestParameters.createLabelRequest)
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, jsonValue => CreateLabelResponseFromJSON(jsonValue))
  }

  /**
   * ラベルを作成する
   * create
   */
  async userV1LabelsPost(
    requestParameters: UserV1LabelsPostRequest = {},
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<CreateLabelResponse> {
    const response = await this.userV1LabelsPostRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * ラベルの並び順を更新する
   * sort
   */
  async userV1LabelsSortPutRaw(
    requestParameters: UserV1LabelsSortPutRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<runtime.ApiResponse<SortLabelsResponse>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/user/v1/labels/sort`,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: SortLabelsRequestToJSON(requestParameters.sortLabelsRequest)
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, jsonValue => SortLabelsResponseFromJSON(jsonValue))
  }

  /**
   * ラベルの並び順を更新する
   * sort
   */
  async userV1LabelsSortPut(
    requestParameters: UserV1LabelsSortPutRequest = {},
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<SortLabelsResponse> {
    const response = await this.userV1LabelsSortPutRaw(requestParameters, initOverrides)
    return await response.value()
  }
}
